var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4BA2FF",
    d: "M15.343 10.363c.605.776.932 1.733.93 2.717c0 1.041-.36 1.997-.956 2.752l-.051.064l-.013-.086a4 4 0 0 0-.043-.21c-.3-1.341-1.268-2.494-2.871-3.428c-1.08-.626-1.702-1.38-1.865-2.238a3.3 3.3 0 0 1 .129-1.594c.122-.4.312-.778.561-1.114l.626-.78a.27.27 0 0 1 .42 0zm.986-.78l-4.175-5.224a.197.197 0 0 0-.308 0L7.672 9.587l-.013.013a5.74 5.74 0 0 0-1.23 3.566c0 3.141 2.494 5.691 5.571 5.691s5.572-2.55 5.572-5.691a5.74 5.74 0 0 0-1.23-3.566zm-7.659.763l.373-.467l.013.085l.03.206c.244 1.299 1.106 2.379 2.55 3.214c1.256.733 1.984 1.573 2.194 2.495a3.3 3.3 0 0 1 .064 1.092v.022l-.017.009a4.2 4.2 0 0 1-1.877.44c-2.357 0-4.273-1.953-4.273-4.362c0-1.033.352-1.984.943-2.734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSui);
export default __webpack_public_path__ + "static/media/sui.04fbe8a7df53dc57ded3ada8c2b10d06.svg";
export { ForwardRef as ReactComponent };